var _g, _path, _g2, _circle, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagForMongolia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#c94747"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 32c0 13.1 8.4 24.2 20 28.3V3.7C10.4 7.8 2 18.9 2 32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 32c0-13.1-8.3-24.2-20-28.3v56.6C53.7 56.2 62 45.1 62 32"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 60.3c3.1 1.1 6.5 1.7 10 1.7s6.9-.6 10-1.7V3.7C38.9 2.6 35.5 2 32 2s-6.9.6-10 1.7v56.6z",
    fill: "#2872a0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.6,
    cy: 4.8,
    r: 0.7,
    fill: "#f9cf02"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.6,
    cy: 4.4,
    r: 0.8,
    fill: "#c94747"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f9cf02"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.6,
    cy: 4.6,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3 3.6c0 .2.1.3.3.3c.2 0 .4-.1.4-.3c0-.1-.1-.1-.1-.2v-.2v.3s0 .1-.1.1s-.1 0-.1-.1s.1-.1.1-.2s0-.1-.1-.2c0-.1-.1-.1-.1-.2c-.1 0 0 .2 0 .2s-.1.1-.1.2v.2s0 .1-.1.1s-.1 0-.1-.1v-.1c0-.1-.1-.1 0-.2c-.1.1 0 .1 0 .2v.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.2 5.6v3.1h.6V5.6h-.6m2.2 0v3.1h.7V5.6h-.7M2 6.1v.3h1.3v-.3H2m0 1.8v.3h1.3v-.3H2m0-2.3h1.3l-.7.4l-.6-.4m0 2.7h1.3l-.7.4l-.6-.4"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.2,
    cy: 35.8,
    r: 3.4,
    fill: "#f9cf02"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#c94747"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2 39.5c-2 0-3.6-1.6-3.6-3.6s1.6-3.6 3.6-3.6s3.6 1.6 3.6 3.6s-1.6 3.6-3.6 3.6m0-6.9c-1.8 0-3.3 1.5-3.3 3.3s1.5 3.3 3.3 3.3s3.3-1.5 3.3-3.3s-1.5-3.3-3.3-3.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2 39.5c-1.1 0-1.9-.9-1.9-1.9s.9-1.9 1.9-1.9c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5v-.4c1.1 0 1.9.9 1.9 1.9c0 1.1-.9 1.9-1.9 1.9c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5v.4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.2,
    cy: 34.1,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.2,
    cy: 37.5,
    r: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagForMongolia);
export default __webpack_public_path__ + "static/media/flag-for-mongolia.6f2cd10ba612108fe3fc15d845374d1b.svg";
export { ForwardRef as ReactComponent };